import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function ProformasPageIntro() {
  return (
    <div className="mb-6 flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
      <p className="max-w-2xl text-sm text-muted-foreground">
        Suivi des proformas générées, de leur validité et de leur contenu avant émission de
        facture.
      </p>
      <Link to="/proformas/new" className={cn(buttonVariants({ size: "sm" }))}>
        <Plus size={14} /> Nouvelle proforma
      </Link>
    </div>
  );
}
